var isMouseSupported = Boolean(window.MouseEvent);
var isTouchSupported = Boolean(window.TouchEvent);
var isPointerSupported = Boolean(window.PointerEvent);

var isMouseTypeEvent = function (e) { return e.pointerType === 'mouse' || (isMouseSupported && e instanceof window.MouseEvent); };
var isTouchTypeEvent = function (e) { return e.pointerType === 'touch' || (isTouchSupported && e instanceof window.TouchEvent); };

/*
 * isPureMouseTypeEvent
 * case 1: pointer event, mouse
 * case 2: pure mouse event, pointer event not supported (e.g. safari)
 * case 3: pure mouse event, pointer supported but it's not pointer event instance
 */
var isPureMouseTypeEvent = function (e) { return e.pointerType === 'mouse' ||
  (isMouseSupported && e instanceof window.MouseEvent &&
    (!isPointerSupported || !(e instanceof window.PointerEvent))); };

function safeCall(fn) {
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    (typeof fn === 'function') && fn.apply(void 0, args);
  }
}

var mouseEvents = ['mousedown', 'mouseup'];
var touchEvents = ['touchstart', 'touchend'];
var pointerEvents = ['pointerdown', 'pointerup'];
var hoverEvents = isPointerSupported ? ['pointerenter', 'pointerleave'] : ['mouseenter', 'mouseleave'];

function ftap(node, ref) {
  var onTouchDown = ref.onTouchDown;
  var onTouchDownCapture = ref.onTouchDownCapture;
  var onTouchUp = ref.onTouchUp;
  var onTouchUpCapture = ref.onTouchUpCapture;
  var onTouchClick = ref.onTouchClick;
  var onTouchClickCapture = ref.onTouchClickCapture;
  var onMouseDown = ref.onMouseDown;
  var onMouseDownCapture = ref.onMouseDownCapture;
  var onMouseUp = ref.onMouseUp;
  var onMouseUpCapture = ref.onMouseUpCapture;
  var onMouseClick = ref.onMouseClick;
  var onMouseClickCapture = ref.onMouseClickCapture;
  var onHoverEnter = ref.onHoverEnter;
  var onHoverEnterCapture = ref.onHoverEnterCapture;
  var onHoverLeave = ref.onHoverLeave;
  var onHoverLeaveCapture = ref.onHoverLeaveCapture;

  var sticking = false;

  function handleDown(e) {
    sticking = true;
    if (isMouseTypeEvent(e)) { safeCall(onMouseDown)(e); }
    if (isTouchTypeEvent(e)) { safeCall(onTouchDown)(e); }
  }

  function handleUp(e) {
    if (isMouseTypeEvent(e)) { safeCall(onMouseUp)(e); }
    if (isTouchTypeEvent(e)) { safeCall(onTouchUp)(e); }
    if (sticking) {
      sticking = false;
      if (isMouseTypeEvent(e)) { safeCall(onMouseClick)(e); }
      if (isTouchTypeEvent(e)) { safeCall(onTouchClick)(e); }
    }
  }

  function handleHoverEnter(e) {
    if (isPureMouseTypeEvent(e)) { safeCall(onHoverEnter)(e); }
  }

  function handleHoverLeave(e) {
    if (isPureMouseTypeEvent(e)) { safeCall(onHoverLeave)(e); }
  }

  var isClickUseCapture = Boolean(
    onTouchDownCapture ||
    onTouchUpCapture ||
    onTouchClickCapture ||
    onMouseDownCapture ||
    onMouseUpCapture ||
    onMouseClickCapture
  );

  var ref$1 =
    isPointerSupported ? pointerEvents : (
      isTouchSupported ? touchEvents : mouseEvents
    );
  var clickInEvent = ref$1[0];
  var clickOutEvent = ref$1[1];

  node.addEventListener(clickInEvent, handleDown);
  node.addEventListener(clickOutEvent, handleUp);

  node.addEventListener(hoverEvents[0], handleHoverEnter);
  node.addEventListener(hoverEvents[1], handleHoverLeave);

  if (isClickUseCapture) {
    node.addEventListener(clickInEvent, handleDown, true);
    node.addEventListener(clickOutEvent, handleUp, true);
  }

  if (Boolean(onHoverEnterCapture || onHoverLeaveCapture)) {
    node.addEventListener(hoverEvents[0], handleHoverEnter, true);
    node.addEventListener(hoverEvents[1], handleHoverLeave, true);
  }

  return function release() {
    node.removeEventListener(clickInEvent, handleDown);
    node.removeEventListener(clickOutEvent, handleUp);

    node.removeEventListener(hoverEvents[0], handleHoverEnter);
    node.removeEventListener(hoverEvents[1], handleHoverLeave);

    if (isClickUseCapture) {
      node.removeEventListener(clickInEvent, handleDown, true);
      node.removeEventListener(clickOutEvent, handleUp, true);
    }

    if (Boolean(onHoverEnterCapture || onHoverLeaveCapture)) {
      node.removeEventListener(hoverEvents[0], handleHoverEnter, true);
      node.removeEventListener(hoverEvents[1], handleHoverLeave, true);
    }
  }
}

var pointerScrubEvents = ['pointerdown', 'pointermove', 'pointerup'];
var touchScrubEvents = ['touchstart', 'touchmove', 'touchend'];
var pointerOverEvents = ['pointerenter', 'pointermove', 'pointerleave'];
var mouseOverEvents = ['mouseenter', 'mousemove', 'mouseleave'];
var cancelEvent = isPointerSupported ? 'pointercancel' : 'touchcancel';

function getScrubEvents() {
  return isPointerSupported ? pointerScrubEvents : touchScrubEvents
}

function getHoverEvents() {
  return isPointerSupported ? pointerOverEvents : mouseOverEvents
}

function fscrub(
  node,
  ref,
  options
) {
  var onStart = ref.onStart;
  var onMove = ref.onMove;
  var onEnd = ref.onEnd;

  onStart = safeCall(onStart);
  onMove = safeCall(onMove);
  onEnd = safeCall(onEnd);
  options = Object.assign({hover: false, mouse: false, touch: true}, options);
  if (options.hover) {
    options.mouse = false;
  }
  var hover = options.hover;
  var mouse = options.mouse;
  var touch = options.touch;
  var isHoverEnabled = Boolean(hover);
  var isMouseEnabled = Boolean(mouse);
  var isTouchEnabled = Boolean(touch);
  var events = hover ? getHoverEvents() : getScrubEvents();
  var endElement = hover ? node : document;

  var startEvent = events[0];
  var moveEvent = events[1];
  var endEvent = events[2];
  var isMoving = false;

  function handleStart(e) {
    isMoving = true;
    if (isMouseEnabled && isMouseTypeEvent(e)) { onStart(e); }
    if (isTouchEnabled && isTouchTypeEvent(e)) { onStart(e); }
    if (isHoverEnabled && isPureMouseTypeEvent(e)) { onStart(e); }
  }

  function handleMove(e) {
    if (isMoving) {
      if (isMouseEnabled && isMouseTypeEvent(e)) { onMove(e); }
      if (isTouchEnabled && isTouchTypeEvent(e)) { onMove(e); }
      if (isHoverEnabled && isPureMouseTypeEvent(e)) { onMove(e); }
    }
  }

  function handleEnd(e) {
    if (isMoving) {
      if (isMouseEnabled && isMouseTypeEvent(e)) { onEnd(e); }
      if (isTouchEnabled && isTouchTypeEvent(e)) { onEnd(e); }
      if (isHoverEnabled && isPureMouseTypeEvent(e)) { onEnd(e); }
      isMoving = false;
    }
  }

  node.addEventListener(startEvent, handleStart);
  endElement.addEventListener(moveEvent, handleMove);
  endElement.addEventListener(endEvent, handleEnd);

  !hover && node.addEventListener(cancelEvent, handleEnd);

  if (!isPointerSupported && isMouseEnabled) {
    node.addEventListener('mousedown', handleStart);
    endElement.addEventListener('mousemove', handleMove);
    endElement.addEventListener('mouseup', handleEnd);
  }

  return function release() {
    node.removeEventListener(startEvent, handleStart);
    endElement.removeEventListener(moveEvent, handleStart);
    endElement.removeEventListener(endEvent, handleStart);

    if (!isPointerSupported && isMouseEnabled) {
      node.removeEventListener('mousedown', handleStart);
      endElement.removeEventListener('mousemove', handleMove);
      endElement.removeEventListener('mouseup', handleEnd);
    }

    !hover && node.removeEventListener(cancelEvent, handleEnd);
  }
}

export { fscrub, ftap };
